$(document).ready(function () {
  window.animation = 0;

  if ($("#CollectionSection").length >= 1) {
    collectionShow();
  }

  //  defining the location of products on the screen
  $(window).scroll(function () {
    var scrollPos = $(window).scrollTop();
    var windowHeight = $(window).height();

    $(".product__img").each(function () {
      var target = $(this);
      var targetPos = $(target).offset().top;
      var targetHeight = $(target).outerHeight();
      if (
        targetPos - 300 <= scrollPos &&
        targetPos + targetHeight > scrollPos &&
        window.animation == 0
      ) {
        console.log("go");
        homepageAnime();

        window.animation = 1;
      }
    });
  });

  if ($("#ProductSection").length >= 1) {
    product_tab();
  }
  scrollMagic();
  animationsuspop();
});

//  animation for the products
function homepageAnime() {
  t1 = gsap.timeline();

  t1.staggerFromTo(
    ".product__img",
    1,
    { y: -10, opacity: 0 },
    { y: 0, opacity: 1 },
    0.2
  )
    .staggerFromTo(
      ".grid-link__title",
      1,
      { y: 10, opacity: 0 },
      { y: 0, opacity: 1 },
      0.5,
      "<="
    )
    .staggerFromTo(
      ".grid-link__meta",
      1,
      { y: 10, opacity: 0 },
      { y: 0, opacity: 1 },
      0.2,
      "<="
    )
    .fromTo(
      ".badge",
      1,
      { zoom: 0, opacity: 0 },
      { zoom: 1, opacity: 1 },
      "<+2"
    )
    .to(".sold-out img", 1, { opacity: 0.4 }, "<+2");
}

function collectionShow() {
  homepageAnime();
  window.animation = 1;
}

function animationsuspop() {
  // console.log("animat");
  setTimeout(() => {
    //   console.log("start");

    let popContainer = $(".privy-tab-container");
    let tl1 = gsap.timeline({
      repeat: -1,
      duration: 1,
      yoyo: true,
      ease: Power1,
    });

    tl1.fromTo(popContainer, { scale: 1 }, { scale: 1.2 });
  }, 3000);
}

function scrollMagic() {
  const controller = new ScrollMagic.Controller();

  if ($("#shopify-section-blog-template").length >= 1) {
    let goBlogRight = new TimelineLite();
    goBlogRight.fromTo(
      ".blog-post-odd",
      1,
      { x: 100, opacity: 0 },
      { x: 0, opacity: 1, ease: Circ.easeInOut }
    );

    let goBlogLeft = new TimelineLite();
    goBlogLeft.fromTo(
      ".blog-post-even",
      1,
      { x: -100, opacity: 0 },
      { x: 0, opacity: 1, ease: Circ.easeInOut }
    );

    $(".scroll-blog").each(function (i) {
      if (i % 2 == 0) {
        new ScrollMagic.Scene({
          triggerElement: this,
          triggerHook: 0.4,
          reverse: false,
        })
          .setTween(goBlogRight)
          .addTo(controller);
        // .addIndicators({
        //   indent: 50,
        // });
      } else {
        new ScrollMagic.Scene({
          triggerElement: this,
          triggerHook: 0.4,
          reverse: false,
        })
          .setTween(goBlogLeft)
          .addTo(controller);
        // .addIndicators({
        //   indent: 50,
        // });
      }
    });
  }
}

function product_tab() {
  console.log("%cProduct_tab", "font-size:36px; color:green");

  let product_tab = $(".product_tab_button");

  product_tab.click(function (e) {
    e.preventDefault();
    let $this = $(this);
    let $inner = $this.parent().find($(".product_tab_inner"));
    let $hiddenPart = $inner.find(".product_tab_hidden");
    console.log($inner);
    console.log($hiddenPart[0].clientHeight);

    if ($this.hasClass("active")) {
      $inner.css({
        height: 0,
      });
      $this.removeClass("active");
    } else {
      $this
        .parent()
        .siblings()
        .find(".product_tab_inner")
        .removeClass("active");
      $this.parent().siblings().find(".product_tab_inner").css({
        height: 0,
      });
      $inner.css({
        height: $hiddenPart[0].clientHeight + 20 + "px",
      });
      $this.addClass("active");
    }
  });
}
